import StripeWrapper from './StripeWrapper';
export default StripeWrapper;
